import gql from 'graphql-tag';

export const VODSET_UPDATE_POSITIONS = gql`
  mutation ($positions: JSON!){
    vodsetUpdatePositions(positions: $positions)
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/vodsets/updatePositions.js